import { get } from "lodash";
import { Store } from "redux";

/**
 * Whether the CAPI toggle is on, from wherever the app keeps its features.
 *
 * Two paths because the two apps that mount the banner flatten the toggles
 * into different slices: MEP into `capi.featureToggles`
 * (frontend-mbl/src/shared/reducers/App/capiReducer.js) and HDR into
 * `header.features` (frontend-hdr/src/pages/actions/header.js). Reading only
 * the first is what made the banner invisible in HDR.
 */
export const getIsEnvBannerEnabled = (store: Store): boolean =>
  get(
    store,
    "capi.featureToggles.isEnvBannerEnabled",
    get(store, "header.features.isEnvBannerEnabled", false)
  );
